/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React, { Component } from 'react';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

import Button from '@tencent/dui/lib/components/Button';
import Checkbox from '@tencent/dui/lib/components/Checkbox';
import Loading from '@tencent/dui/lib/components/Loading';
import Modal from '@tencent/dui/lib/components/Modal';
import Provider from '@com/provider';
import { RenderPostionType } from '@src/js/constant';
import ScaleSlide from '@editor/src/page/index/components/canvas/scale-slide';
import SlideModel from '@src/slide/domain/ui-model/element-modeles/slide-model';
import Styles from './index-wrapper.less';
import classNames from 'classnames';
import type { propsType } from './types';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import i18n from '@i18next/i18n';
import { UiDataService } from '@src/slide/domain/ui-model/service/ui-data-service';
import { SelectionService } from '@src/slide/application/service/selection/selection-service';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import PresentationModel from '@src/slide/domain/ui-model/element-modeles/presentation-model';
import { importSlidesV3, updatePresentationBySelectedV3 } from '@com-pc/paging-selection/utils';
import { IPresentationDataModel, SlideFile } from '@tencent/slide-sdk-model';
import { assert } from 'ts-essentials';
import { IPagingSelectionManagerData } from '@src/slide/application/service/paging-selection/core/paging-selection-manager.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IPresentationStoreService } from '@src/slide/domain/slide-app/core/interfaces/presentation-service.interface';

const SLIDE_WIDTH = 155;
const SLIDE_HEIGHT = 87;

export default class IndexWrapper extends Component<propsType, {
    slideList: Array<SlideModel | { id: string }>;
    selectedList: Set<string>;
    visible: boolean;
    keepScale: boolean;
    lastPointerPos: number;
}> {
    modalRef: Modal | null;
    confirmTimer;
    private cloneUiDataService?: IUiDataService;
    private cloneSelectionService?: ISelectionService;
    private clonePresentationStoreService?: IPresentationStoreService;

    constructor(props: propsType, context: any) {
        super(props, context);
        this.state = {
            slideList: [],
            selectedList: new Set(),
            visible: false,
            keepScale: true,
            lastPointerPos: 0,
        };

        this.handlerUpdate(props.data);
    }

    createNewSdkData(presentationStr: string) {
        try {
            const isV3Data = !presentationStr.includes('slideWidth');
            const PresentationStoreService = SlideDataServices.SDKDataServices.PresentationStoreService();
            assert(PresentationStoreService, 'PresentationStoreService is not ready');
            if (isV3Data) {
                this.clonePresentationStoreService = PresentationStoreService
                    .createFromCommandData(new SlideFile(JSON.parse(presentationStr)).getCommandData());
            } else {
                this.clonePresentationStoreService = PresentationStoreService
                    .createFromOldPresentationData(presentationStr);
            }
            return this.clonePresentationStoreService.getPresentation();
        } catch (e) {
            SlideDataServices.UI.Snackbar.promise().then((snackbar) => {
                snackbar.show({
                    message: i18n.t('很抱歉，选择的文档不支持导入'),
                    autoClose: true,
                    duration: 3000,
                });
            });
            this.props.onClose();
            return;
        }
    }

    // 处理数据更新
    handlerUpdate(data: IPagingSelectionManagerData) {
        let presentation: IPresentationDataModel | undefined = undefined;
        if (data.presentationData) {
            presentation = data.presentationData;
        } else {
            presentation = this.createNewSdkData(data.presentationStr);
        }
        if (!presentation) return;
        this.cloneUiDataService = new UiDataService();
        this.cloneSelectionService = new SelectionService(this.cloneUiDataService);
        this.cloneUiDataService.presentation = new PresentationModel({});
        this.cloneUiDataService.presentation.asyncConvertChildren = false;
        this.cloneUiDataService.presentation.bindSDK(presentation);
        this.cloneUiDataService.presentation?.children?.forEach((children) => {
            children.startConvertChildrenTask();
        });

        // eslint-disable-next-line
        this.state = {
            slideList: presentation.slideList.map(({ id }) => ({ id })),
            selectedList: new Set(),
            visible: true,
            keepScale: true,
            lastPointerPos: 0,
        };
    }

    handlerCancel() {
        this.cancelAllTask();
        this.setState({ visible: false });
    }

    handlerDestroy() {
        tdw({
            opername: TDWOperationType.PAGING_SELECTION,
            module: TDWModuleType.SLIDE_PREVIEW,
            action: TDWActionType.CANCEL_INSERT,
        });
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.INSERT_SLIDE,
            action: TDWActionType.INSERT_SLIDE_CANCEL,
            ver6: this.props.data.source,
        });
        this.handlerCancel();
        this.props.onClose();
    }

    /**
     * 取消所有待执行的 task
     */
    cancelAllTask() {
        this.cloneUiDataService?.presentation?.children
            ?.forEach(slide => slide.cancelConvertChildrenTask());
    }
    /**
     * 用于标识是否全部选择
     * @computed 计算属性
     * @returns
     */
    isSelectAll() {
        return this.state.slideList.length === this.selectedCount();
    }

    /**
     * 用于标识没有任何选择
     * @computed 计算属性
     * @returns
     */
    isSelectNone() {
        return this.selectedCount() === 0;
    }

    /**
     * 当前选中数量
     * @computed 计算属性
     * @returns
     */
    selectedCount() {
        return this.state.selectedList.size;
    }

    /**
     * 全选/反选逻辑
     */
    toggleSelectAll() {
        this.setState({
            selectedList: this.isSelectAll()
                ? new Set()
                : this.createSetContainsAllSlideId(),
        });
        this.calculateLastPointerPos();
    }


    createSetContainsAllSlideId(): Set<string> {
        return new Set(this.state.slideList.map((slide: SlideModel) => this.getModelId(slide.id)));
    }

    /**
     * 自动缩放状态切换
     */
    toggleKeepScale() {
        this.setState({
            keepScale: !this.state.keepScale,
        });
    }

    /**
     * 常规点击选中/反选事件
     * @param slideId
     */
    normalClick(slideId: string) {
        const { selectedList } = this.state;
        selectedList.has(slideId) ? selectedList.delete(slideId) : selectedList.add(slideId);
        this.setState({ selectedList });
    }

    /**
     * 处理按下 shift 快速选择的响应
     * @param curPointerPos
     */
    clickWithShift(curPointerPos: number) {
        const getMinAndMax = (v1, v2) => (v1 < v2 ? ({ min: v1, max: v2 }) : ({ min: v2, max: v1 }));
        const { lastPointerPos, selectedList, slideList } = this.state;
        const { min, max } = getMinAndMax(lastPointerPos, curPointerPos);
        slideList
            .slice(min, max + 1)
            .forEach(slide => selectedList.add(this.getModelId(slide.id)));
        this.setState({
            selectedList,
        });
    }

    /**
     * 鼠标点击缩略图事件，包含常规单选和快速多选
     * @param e
     * @param curSlideId
     * @param curPointerPos
     */
    handlerMouseDown(e: React.MouseEvent<HTMLDivElement, MouseEvent>, curSlideId: string, curPointerPos: number) {
        e.stopPropagation();
        e.preventDefault();
        e.shiftKey ? this.clickWithShift(curPointerPos) : this.normalClick(curSlideId);
        this.calculateLastPointerPos(curPointerPos);
    }

    /**
     * 简单计算鼠标上一次点位，如果是全选或者反选，定位重置到 0
     * @param curPointerPos
     */
    calculateLastPointerPos(curPointerPos = 0) {
        this.setState({
            // 如果当前
            lastPointerPos: (this.isSelectAll() || this.isSelectNone()) ? 0 : curPointerPos,
        });
    }

    /**
     * 处理键位事件，目前主要响应全选
     * @param e
     */
    handlerKeyDown(e: KeyboardEvent) {
        const keyCode = e.key;
        const ctrlKey = e.ctrlKey || e.metaKey;
        if (ctrlKey && keyCode === 'a') {
            e.preventDefault();
            this.setState({
                selectedList: this.createSetContainsAllSlideId(),
            });
            this.calculateLastPointerPos();
        }
    }

    async confirmToImport() {
        tdw({
            opername: TDWOperationType.PAGING_SELECTION,
            module: TDWModuleType.SLIDE_PREVIEW,
            action: TDWActionType.CONFIRM_INSERT,
        });
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.INSERT_SLIDE,
            action: TDWActionType.INSERT_SLIDE_SUC,
            ver6: this.props.data.source,
        });
        this.handlerCancel();
        const originPresentation = this.getUiDataService().presentation.sdkData as IPresentationDataModel;
        const importPresentation = this.cloneUiDataService?.presentation.sdkData as IPresentationDataModel;
        const selectedSlides = importPresentation.slideList
            .filter(({ id }) => this.state.selectedList.has(id));
        await updatePresentationBySelectedV3(
            originPresentation,
            importPresentation,
            selectedSlides,
            this.state.keepScale,
        );
        const importPresentationData = importPresentation.getWritableOwnedData();
        // FIXME 目前分页导入不支持显示批注。因为分页导入后，批注后台有bug会重复提交批注数据，导致批注重复，待批注后台同学修复之后再考虑支持.
        importPresentationData.slideList.forEach((slide) => {
            delete slide.commentGroupMap;
        });
        this.clonePresentationStoreService?.dispose();
        const { data: { useCurrentSlideIndex }, onClose } = this.props;
        importSlidesV3(importPresentationData, onClose, useCurrentSlideIndex);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handlerKeyDown.bind(this));
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.data.presentationStr !== '') {
            this.handlerUpdate(nextProps.data);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handlerKeyDown.bind(this));
    }

    render() {
        return (
            <Provider>
                <Modal
                    ref={ref => this.modalRef = ref}
                    className={classNames({
                        [Styles.modal]: true,
                        'paging-selection-wrapper-modal': true,
                    })}
                    title={i18n.t('选择导入的幻灯片')}
                    visible={this.state.visible}
                    footer={null}
                    cancelText=""
                    onCancel={this.handlerDestroy.bind(this)}
                >
                    <div className={Styles['top-bar']}>
                        <div className={Styles['file-name']}>
                            {i18n.t('已选')}{this.selectedCount()}/{this.state.slideList.length}
                        </div>
                        <Checkbox className={Styles['select-all']}
                            checked={this.isSelectAll()}
                            onChange={this.toggleSelectAll.bind(this)}>{i18n.t('全选')}</Checkbox>
                    </div>
                    <div className={Styles.container}>
                        {
                            this.cloneUiDataService
                                ?.presentation?.children?.map((slideModel: SlideModel, index) => (
                                    <div className={classNames({
                                        [Styles['slide-item']]: true,
                                        [Styles['slide-item-selected']]: this.state.selectedList.has(this.getModelId(slideModel.id)),
                                    })}
                                    key={`${slideModel.key}${index}`}
                                    // onClick={() => this.handlerClick(slideModel.sdkData.id, index)}
                                    onMouseDown={
                                        e => this.handlerMouseDown(e, this.getModelId(slideModel.id), index)}
                                    >
                                        {slideModel.key
                                            ? <ScaleSlide
                                                width={SLIDE_WIDTH}
                                                height={SLIDE_HEIGHT}
                                                isShown={true}
                                                slideModel={slideModel}
                                                uiDataService={this.cloneUiDataService}
                                                shouldUpdate={false}
                                                fromScale={0}
                                                region={RenderPostionType.PAGINGSELECTION}
                                                isTemplate={true}
                                                styles={{
                                                    containerStyle: {
                                                        opacity: slideModel.isShowInPlay ? undefined : 0.5,
                                                    },
                                                }}
                                            />
                                            : <Loading visible={true} style={{ width: '24px', height: '24px' }} />}
                                        <p>{index + 1}</p>
                                    </div>
                                ))
                        }
                    </div>
                    <div className={Styles.footer}>
                        <Checkbox
                            className={
                                Styles['keep-scale']
                            }
                            checked={this.state.keepScale}
                            onChange={this.toggleKeepScale.bind(this)}
                        >
                            {i18n.t('自动缩放')}
                        </Checkbox>
                        <Button
                            className={
                                Styles['import-btn']
                            }
                            type="primary"
                            size="large"
                            disabled={this.isSelectNone()}
                            onClick={this.confirmToImport.bind(this)}
                        >{i18n.t('导入幻灯片')}</Button>
                    </div>
                </Modal>
            </Provider>
        );
    }

    private getModelId = (id: string | null): string => id ?? String(id);

    private getAppServices(): IEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IEditorAppServices;
    }

    private getSelectionService(): ISelectionService {
        return this.getAppServices().viewableServiceLayer.selectionService;
    }

    private getUiDataService(): IUiDataService {
        return this.getAppServices().getUiDataService();
    }
}
